import { render } from "./logo-text.svg?vue&type=template&id=2326b42f?inline"
const script = {}
script.render = render

export default script